import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Ethnic Minority and Physically Disable Report ")
  ])
], -1)
const _hoisted_2 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_3 = { class: "collapse show" }
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Partner", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "col-md-2 mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "row w-100 mb-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_19 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "table table-borderless gy-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "2"
    }, "Sl"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "2"
    }, "Training Partner"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      rowspan: "2"
    }, "Trade Name"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      colspan: "2"
    }, "Ethnic Group"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid black !important","text-align":"center"},
      colspan: "2"
    }, "Physically Challenged")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid black !important","text-align":"center"} }, " Female ")
  ])
], -1)
const _hoisted_28 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }
const _hoisted_29 = {
  style: {"border":"1px solid black !important","text-align":"center"},
  colspan: "7"
}
const _hoisted_30 = {
  class: "align-middle",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_31 = {
  class: "align-middle",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_32 = {
  class: "align-middle",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_33 = {
  class: "align-middle",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_34 = {
  class: "align-middle",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_35 = {
  class: "align-middle",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_36 = {
  class: "align-middle",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}, null, -1)
const _hoisted_38 = {
  colspan: "2",
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_39 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_40 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_41 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_42 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_43 = {
  colspan: "3",
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_44 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_45 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_46 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_47 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}, " Grand Total ", -1)
const _hoisted_49 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_50 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_51 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}
const _hoisted_52 = {
  class: "align-middle font-weight-bold",
  style: {"border":"1px solid black !important","text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("div", {
        class: "card mb-5 mb-xl-10",
        key: _ctx.componentKey
      }, [
        _hoisted_1,
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _hoisted_9,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      options: _ctx.optionsTranche,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Tranche",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _hoisted_12,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      options: _ctx.optionsTPartner,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Training Partner",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getData())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_14
                    ])
                  ])
                ]),
                (_ctx.showCourseNotice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                              title: "Download Xlse",
                              "data-v-54b12dc8": "",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportTrainee()))
                            }, _hoisted_21),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Download PDF",
                              "data-v-54b12dc8": "",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadPdf()))
                            }, _hoisted_23),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Print",
                              "data-v-54b12dc8": "",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printPdf()))
                            }, _hoisted_25)
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranchewiseData, (data, tranche) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: tranche }, [
                                _createElementVNode("tr", _hoisted_28, [
                                  _createElementVNode("td", _hoisted_29, _toDisplayString(data?.trancheInfo?.label), 1)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data?.trancheInfo?.entities, (info, entity) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: entity }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.course_list, (inf, count) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: count }, [
                                        _createElementVNode("td", _hoisted_30, _toDisplayString(inf?.sl), 1),
                                        _createElementVNode("td", _hoisted_31, _toDisplayString(info?.entity_short_name), 1),
                                        _createElementVNode("td", _hoisted_32, _toDisplayString(inf?.course_name), 1),
                                        _createElementVNode("td", _hoisted_33, _toDisplayString(inf?.ethnic_count), 1),
                                        _createElementVNode("td", _hoisted_34, _toDisplayString(inf?.ethnic_count_female), 1),
                                        _createElementVNode("td", _hoisted_35, _toDisplayString(inf?.challenged_count), 1),
                                        _createElementVNode("td", _hoisted_36, _toDisplayString(inf?.challenged_count_female), 1)
                                      ]))
                                    }), 128)),
                                    _createElementVNode("tr", null, [
                                      _hoisted_37,
                                      _createElementVNode("td", _hoisted_38, " Sub Total of " + _toDisplayString(info?.entity_short_name), 1),
                                      _createElementVNode("td", _hoisted_39, _toDisplayString(Number(info?.total_ethnic).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_40, _toDisplayString(Number(info?.total_ethnic_female).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_41, _toDisplayString(Number(info?.total_challenged).toLocaleString()), 1),
                                      _createElementVNode("td", _hoisted_42, _toDisplayString(Number(info?.total_challenged_female).toLocaleString()), 1)
                                    ])
                                  ], 64))
                                }), 128)),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_43, " Subtotal of " + _toDisplayString(data?.trancheInfo?.label), 1),
                                  _createElementVNode("td", _hoisted_44, _toDisplayString(Number(
                                data?.trancheInfo?.tranche_total_ethnic
                              ).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_45, _toDisplayString(Number(
                                  data?.trancheInfo?.tranche_total_ethnic_female
                                ).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_46, _toDisplayString(Number(
                                data?.trancheInfo?.tranche_total_challenged
                              ).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_47, _toDisplayString(Number(
                                  data?.trancheInfo?.tranche_total_challenged_female
                                ).toLocaleString()), 1)
                                ])
                              ], 64))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _hoisted_48,
                              _createElementVNode("td", _hoisted_49, _toDisplayString(Number(_ctx.grandTotalEthnic).toLocaleString()), 1),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(Number(_ctx.grandTotalEthnicFemale).toLocaleString()), 1),
                              _createElementVNode("td", _hoisted_51, _toDisplayString(Number(_ctx.grandTotalChallenged).toLocaleString()), 1),
                              _createElementVNode("td", _hoisted_52, _toDisplayString(Number(_ctx.grandTotalChallengedFemale).toLocaleString()), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      ]))
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}